import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

export interface VideoLink {
    type: string;
    id: string | null;
    link: SafeResourceUrl;
    src: string;
}

export function videoLinkUpload(link: string | null, domSanitizer: DomSanitizer): VideoLink | null {
    if (!link) {
        return null;
    }

    link = link.replace(/(<([^>]+)>)/gi, "");

    if (link.includes('youtube')) {
        const type: "youtube" = 'youtube';
        const [protocol, , id] = link.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/|live\/)/);
        const videoId: string | null = id?.split(/[^0-9a-z_-]/i)[0] || null;
        const videoLink: SafeResourceUrl = domSanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + videoId + '?autoplay=0');
        return {type, id: videoId, link: videoLink, src: ''};
    } else if (link.includes('vimeo')) {
        const type: "vimeo" = 'vimeo';
        let formattedLink: string = link
        if (formattedLink.includes('?')) {
            formattedLink = formattedLink.split('?')[0]
        }
        if (formattedLink.includes('vimeo.com/')) {
            formattedLink = formattedLink.split('vimeo.com/')[1]
        } else {
            formattedLink = formattedLink.substr(formattedLink.length - 9);
        }
        const id: string = formattedLink;
        const videoLink: SafeResourceUrl = domSanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/' + id + '?autoplay=0');
        return {type, id, link: videoLink, src: ''};
    } else {
        const videoLink: SafeResourceUrl = domSanitizer.bypassSecurityTrustResourceUrl(link);
        return {type: 'api', id: null, link: videoLink, src: ''};
    }
}
